function KnotAProblem() {
  return (
    <div className="project">
      <div className="project-image">
        {/* <img
          id="knotaproblem-image"
          alt="Knot a Problem"
          className="project-pad-left"
          src={KnotAProblemImage}
        ></img> */}
        <iframe
          title="Knot A Problem Prototype"
          id="knotaproblem-prototype"
          src="https://www.figma.com/embed?embed_host=share&url=https%3A%2F%2Fwww.figma.com%2Fproto%2FBeyda8QtppptPjAg3s854P%2FKnot-A-Problem%3Fpage-id%3D0%253A1%26node-id%3D196-271%26viewport%3D635%252C-136%252C0.27%26scaling%3Dscale-down%26starting-point-node-id%3D196%253A271"
          allowFullScreen
        ></iframe>
      </div>
      <div className="project-caption">
        <h2>Knot A Problem</h2>
        <h3>
          February - April 2023 • IS 4300 (Human-Computer Interaction) Final
          Project
        </h3>
        <h3>
          <a
            href="https://www.figma.com/file/Beyda8QtppptPjAg3s854P/Knot-A-Problem?node-id=0%3A1&t=i1XgkSsCTn18IQ7m-1"
            target="_blank"
            rel="noopener noreferrer"
          >
            Wireframe
          </a>{" "}
          •{" "}
          <a
            href="https://www.figma.com/proto/Beyda8QtppptPjAg3s854P/Knot-A-Problem?page-id=0%3A1&node-id=196-271&viewport=635%2C-136%2C0.27&scaling=scale-down&starting-point-node-id=196%3A271"
            target="_blank"
            rel="noopener noreferrer"
          >
            Prototype
          </a>{" "}
          •{" "}
          <a
            href="/projects"
            target="_blank"
            rel="noopener noreferrer"
            style={{ pointerEvents: "none", cursor: "default" }}
          >
            Report (Coming Soon)
          </a>
        </h3>
        <em>Figma</em>
        <p>
          Designed an app for knot-tying tutorials. Went through the entire
          design process, from conception, low and high-fidelity prototyping,
          and usability testing.
        </p>
      </div>
    </div>
  );
}

export default KnotAProblem;
